import React from 'react';
import Parser from 'html-react-parser';
import Avatar from '../common/Avatar';
import Username from '../common/Username';
import Moment from 'react-moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const CommentItem = (props) => (
    <div className="panel-adt clearfix">

        <div className="avatar-img pull-left">
            <Avatar image={props.users[props.item.user].avatar} rank={props.ranks[props.users[props.item.user].rank]} width="32" height="32" />
        </div>

        <div>
            <Username user={props.users[props.item.user]} rank={props.ranks[props.users[props.item.user].rank]} placement="left" />
            <div className="avatar-date timestamp">
                <OverlayTrigger placement="top" overlay={<Tooltip id="activity-feed-post-date"><Moment format="ddd MMM D YYYY">{props.item.created}</Moment></Tooltip>}>
                    <Moment fromNow>{props.item.created}</Moment>
                </OverlayTrigger>
            </div>
            <div className="ql-snow">
                <div className="comment ql-editor">
                    {Parser(props.item.body, {
                        replace: function(domNode) {
                            if (domNode.type === 'sup') {
                                return React.createElement('sup', {}, 'replaced');
                            }
                        }
                    })}
                </div>
            </div>
        </div>
    </div>
);

export default CommentItem;


// WEBPACK FOOTER //
// ./src/common/CommentItem.js